import { ChangeDetectionStrategy, Component, ElementRef, ViewChild } from '@angular/core';
import { MenuComponent } from '@go-modules/components/menus/menu/menu.component';

@Component({
	selector: 'menu-button',
	templateUrl: 'menu-button.component.html',
	styleUrls: ['./menu-button.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class MenuButtonComponent {
	@ViewChild(MenuComponent) public menuComponent: MenuComponent;
	@ViewChild('menuButton', {read: ElementRef}) public menuButton: ElementRef;

	constructor () {}

	public openMenu (event: MouseEvent) {
		event.stopPropagation();
		event.preventDefault();

		this.menuComponent.openMenu(event, this.menuButton.nativeElement);
	}
}
